export const CONFIG:Config = {
    order_and_collect: {
        order: {
            requiredReference_relnrs: ['128', '24122'],
            enable_foreign_currency: true
        },
        collect: {
            requiredReference_relnrs: ['128', '24122']
        }
    }
}

interface Config {
    order_and_collect: {
        order: {
            requiredReference_relnrs: string[],
            enable_foreign_currency: boolean
        },
        collect: {
            requiredReference_relnrs: string[]
        }
    }
}